module.exports = __webpack_public_path__ + "fonts/Gilroy-Light.25e5ce97.ttf";